export const APP_VERSION = '2.3.1';
export const RELEASE_DATE = 'Jan 2025';

export const changeLogs = [
    {
        type: 'improved',
        title: 'Market List UI Refinements',
        description: 'Rearranged Markets List for enhanced readability and user experience.'
    },
    {
        type: 'improved',
        title: 'Order Book Visual Updates',
        description: 'Restyled Order Books with improved layout and visual clarity for better market depth visibility.'
    },
    {
        type: 'improved',
        title: 'Other UI Enhancements',
        description:
            'Tweaks and refinements to the interface for smoother navigation, better readability, and a polished look.'
    },
    {
        type: 'fixed',
        title: 'Balance Decimal Rounding',
        description: 'Fixed incorrect decimal point rounding in balances to ensure accurate value representation.'
    },
    {
        type: 'fixed',
        title: 'Ticker Price Decimal Accuracy',
        description: 'Fixed ticker order price decimal precision, including VWAP calculations.'
    },
    {
        type: 'fixed',
        title: 'Other Bug Fixes',
        description: 'Resolved minor issues of missing values and updated translation mistakes.'
    }
];
